import React from 'react'
import { DefaultLayout } from '../../layouts'
import { PageHeader, ContentNav, Summaries, /* SimpleCard */ } from './components'
import { Container } from '../../components'
import { normalizer } from '../../utils'
import {
  MainContent as MainContentBlog,
  MainContentMobile as MainContentMobileBlog
} from '../blog/components'
import {
  MainContent as MainContentEvent,
  MainContentMobile as MainContentMobileEvent
} from '../event/components'
import {
  MainContent as MainContentResource,
  MainContentMobile as MainContentMobileResource
} from '../resource/components'
import {
  MainContent as MainContentOrganization,
  MainContentMobile as MainContentMobileOrganization
} from '../organization/components'
import {
  MainContent as MainContentProgram,
  MainContentMobile as MainContentMobileProgram
} from '../program/components'
import rawData from '../../database/regions.json'
const normalized = normalizer(rawData)

const RegionDetail = (props) => {
  const { match } = props
  const data = normalized[match.params.id]
  const contentRoute = props.contentRoute ? props.contentRoute : 'Summary';
  // const isUnique = (contentRoute === 'Summary' || contentRoute === 'Event' || contentRoute === 'Blog')

  return (
    <DefaultLayout>
      <PageHeader data={data}/>

      <div className="lg:hidden">
        <ContentNav route={contentRoute} data={data} mobile/>
      </div>

      <Container>
        <div className="pt-8 lg:mb-0 hidden lg:block">
          <ContentNav route={contentRoute} data={data}/>
        </div>
      </Container>

      {
        contentRoute === 'Summary' &&
        <Container color="#f5f5f5" className="pt-8 lg:pt-20">
          <div className="flex flex-wrap -mx-4">
            <div className="lg:w-7/12 px-4 lg:pr-8">
              <div className="prose blog-content" dangerouslySetInnerHTML={{__html: data.content}} />
            </div>
            <div className="lg:w-5/12 px-4">
              <img src={`/images/region/${data.image}`} alt={data.name}/>
            </div>
          </div>

          <Summaries data={data}/>
        </Container>
      }
      {
        contentRoute === 'Event' &&
        <div>
          <div className="lg:hidden">
            <MainContentMobileEvent embed={true}/>
          </div>
          <MainContentEvent embed={true}/>
        </div>
      }
      {
        contentRoute === 'Blog' &&
        <div>
          <div className="lg:hidden">
            <MainContentMobileBlog embed={true}/>
          </div>
          <MainContentBlog embed={true}/>
        </div>
      }
      {
        contentRoute === 'kebijakan-kota-daerah' &&
        <div className="pt-8 lg:pt-16" style={{backgroundColor: '#f5f5f5'}}>
          <div className="lg:hidden">
            <MainContentMobileResource embed={true} byId={true} resourceIds={data.resources} resourceCategoryId={2}/>
          </div>
          <MainContentResource embed={true} byId={true} resourceIds={data.resources} resourceCategoryId={2}/>
        </div>
      }
      {
        contentRoute === 'Hasil Penelitian' &&
        <div className="pt-8 lg:pt-16" style={{backgroundColor: '#f5f5f5'}}>
          <div className="lg:hidden">
            <MainContentMobileResource embed={true} byId={true} resourceIds={data.resources} resourceCategoryId={3}/>
          </div>
          <MainContentResource embed={true} byId={true} resourceIds={data.resources} resourceCategoryId={3}/>
        </div>
      }
      {
        contentRoute === 'Kasus' &&
        <div className="pt-8 lg:pt-16" style={{backgroundColor: '#f5f5f5'}}>
          <div className="lg:hidden">
            <MainContentMobileResource embed={true} byId={true} resourceIds={data.resources} resourceCategoryId={7}/>
          </div>
          <MainContentResource embed={true} byId={true} resourceIds={data.resources} resourceCategoryId={7}/>
        </div>
      }
      {
        contentRoute === 'Organisasi' &&
        <div className="pt-8 lg:pt-16" style={{backgroundColor: '#f5f5f5'}}>
          <div className="lg:hidden">
            <MainContentMobileOrganization embed={true} byId={true} organizationIds={data.organizations}/>
          </div>
          <MainContentOrganization embed={true} byId={true} organizationIds={data.organizations}/>
        </div>
      }
      {
        contentRoute === 'Inisiatif' &&
        <div className="pt-8 lg:pt-16" style={{backgroundColor: '#f5f5f5'}}>
          <div className="lg:hidden">
            <MainContentMobileProgram embed={true} byId={true} programIds={data.initiatives}/>
          </div>
          <MainContentProgram embed={true} byId={true} programIds={data.initiatives}/>
        </div>
      }
      {/* {
        !isUnique &&
        <div>
          <div className="lg:hidden">
            <MainContentMobileResource embed={true} byId={true} resourceIds={data.resources}/>
          </div>
          <MainContentResource embed={true} byId={true} resourceIds={data.resources}/>
        </div>
      } */}
    </DefaultLayout>
  )
}

export { RegionDetail }
